import type { CloseReasonCategory, Deal, DealOutcomeKind, IndustryVertical } from "@/api/client";

export const INDUSTRY_LABELS: Record<IndustryVertical, string> = {
  healthcare: "Healthcare",
  finance: "Finance",
  utilities: "Utilities",
  logistics: "Logistics",
  government: "Government",
  technology: "Technology",
  retail: "Retail",
};

export const CLOSE_REASON_LABELS: Record<CloseReasonCategory, string> = {
  lost_to_competitor: "Lost to competitor",
  project_cancelled: "Project cancelled / defunded",
  no_progress: "No progress / unresponsive client",
  other: "Other",
};

/**
 * CHP-777: lead-in sentence for a declined outcome, so decline + reason copy
 * standardises to "<Outcome> declined. Reason: <text>" everywhere (the outcome
 * feed card and the deal-detail Status rationale). Maps each declined
 * `DealOutcomeKind` to its outcome phrase; non-declined kinds return null.
 */
export function declinedOutcomeLeadIn(outcome: DealOutcomeKind | null): string | null {
  switch (outcome) {
    case "registration_declined":
      return "Deal registration declined.";
    case "extension_declined":
      return "Deal extension declined.";
    case "closed_won_declined":
      return "Closed-won submission declined.";
    default:
      return null;
  }
}

/** Closed-lost rationale for display: "<reason> — <notes>" (CHP-239/246). */
export function closeReasonText(deal: Deal): string {
  const label = deal.close_reason_category
    ? (CLOSE_REASON_LABELS[deal.close_reason_category] ?? deal.close_reason_category)
    : null;
  if (label && deal.close_notes) return `${label} — ${deal.close_notes}`;
  return label ?? deal.close_notes ?? "—";
}
